import React, { memo } from 'react';
import { pdfStyles } from '../pdfStyles';
import { Page } from '@react-pdf/renderer';
import { FooterCompany } from '../comps';
import { isEqual } from 'lodash';
import { ColorSet } from 'src/redux/reducers/theme';
import { useAuth } from 'src/state/auth';

interface AssessmentEndProps {
  assessmentName: string;
  orientation?: 'portrait' | 'landscape';
  colors: ColorSet;
  label?: string;
  logoSrc?: string;
  primaryColor?: string | null;
  secondaryColor?: string | null;
}

export const AssessmentEnd: React.FC<AssessmentEndProps> = memo(
  ({ assessmentName, colors, orientation, label, logoSrc, primaryColor, secondaryColor }) => {
    const { profile } = useAuth();

    return (
      <Page size={'A4'} wrap style={pdfStyles.page} orientation={orientation}>
        <FooterCompany
          companyName={profile?.activeWorkspace?.name || ''}
          title={assessmentName}
          label={label || 'RISK ASSESSMENT'}
          companyImage={undefined}
          colors={colors}
          logoSrc={logoSrc}
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
        />
      </Page>
    );
  },
  (prevProps, nextProps) => isEqual(prevProps, nextProps),
);
